<template lang="pug">
  v-app
    v-app-bar.appbar(
      app
      color="primary"
      height="70"
      )
      .logo.d-flex
        v-img(
          alt="Ticketeer logo"
          contain
          min-width="150"
          src="./assets/logo.svg"
          width="150"
          height="65")

      v-spacer

      v-btn(
        href="https://github.com/5eraph/ts"
        target="_blank"
        text)
        span.mr-2.latest-release Latest Release
        v-icon mdi-open-in-new

    v-content(style="padding: 0")
      Home
</template>

<script>
import Home from './views/Home';

export default {
  name: 'App',

  components: {
    Home,
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="stylus" scoped>
>>> .appbar 
  width 100vw !important


.appbar >>> .v-toolbar__content
  position relative

  
.logo 
  position absolute
  width 100%
  height 100%
  justify-content center
  left 0
  top 0
  padding 4px 16px

@media (max-width: 625px) {
  .logo {
    position absolute
    justify-content start
    align-items start
    width auto
  }
}

@media (max-width: 400px) {
  .latest-release {
    display none
  }
}
</style>
